import { CampaignObject } from "../types/APITypes";
import { usePost } from "./requestAPI/apiPost";


type ResubmitCampaignResponse = {
    result: string;
}

type UseResubmitCampaignResponse = [
    (data: CampaignObject) => Promise<ResubmitCampaignResponse | null>,
    {
        value?: ResubmitCampaignResponse;
        loading: boolean;
        called: boolean;
        error?: string;
        isSuccess: boolean;
    }
]

export const useResubmitCampaign = (): UseResubmitCampaignResponse => {
    
    const [post, postState] = usePost<ResubmitCampaignResponse, CampaignObject>({
        url: `campaign/resubmit-campaign`
    })

    const resubmitCampaign = async (
        data : CampaignObject
    ) : Promise<ResubmitCampaignResponse | null> => {

        const result = await post(data);
        return result;
    }

    return [resubmitCampaign, postState];
};